import { ManualProcessOption, TransactionOptionsGroup } from "@shared/models/select-option.interface";

export const PAYMENT_FILTER_OPTIONS: TransactionOptionsGroup[] = [
	{
		name: "Status",
		type: "status",
		options: [
			{ text: "All statuses", value: "statuses", group: "statusOption", selected: false, disable: false },
			{ text: "Booked", value: "BOOKED", group: "statusOption", selected: false, disable: false },
			{ text: "Created", value: "CREATED", group: "statusOption", selected: false, disable: false },
			{ text: "Error", value: "ERROR", group: "statusOption", selected: false, disable: false },
			{
				text: "Failed",
				value: "FAILED,ATTEMPTS_LIMIT_EXCEEDED",
				group: "statusOption",
				selected: false,
				disable: false
			},
			{
				text: "Failed to book",
				value: "FAILED_TO_BOOK",
				group: "statusOption",
				selected: false,
				disable: false
			},
			{ text: "Processed", value: "PROCESSED", group: "statusOption", selected: false, disable: false },
			{
				text: "Processing",
				value: "PROCESSING,PENDING",
				group: "statusOption",
				selected: false,
				disable: false
			}
		]
	},
	{
		name: "Bulk Actions",
		type: "bulk",
		options: [
			{
				text: "Inactivate",
				value: "INACTIVATE",
				group: "bulkOption",
				selected: false,
				disable: false,
				statusesLinked: ["BOOKED", "FAILED,ATTEMPTS_LIMIT_EXCEEDED", "FAILED_TO_BOOK", "FAILED"],
				buttonText: "INACTIVATE"
			},
			{
				text: "Mark as booked",
				value: "MARK_AS_BOOKED",
				group: "bulkOption",
				selected: false,
				disable: false,
				statusesLinked: ["CREATED", "FAILED_TO_BOOK"],
				buttonText: "MARK AS BOOKED"
			},
			{
				text: "Mark as processed",
				value: "MARK_AS_PROCESSED",
				group: "bulkOption",
				selected: false,
				disable: false,
				statusesLinked: ["FAILED,ATTEMPTS_LIMIT_EXCEEDED", "FAILED"],
				buttonText: "MARK AS PROCESSED"
			},
			{
				text: "Reprocess",
				value: "REPROCESS",
				group: "bulkOption",
				selected: false,
				disable: false,
				statusesLinked: ["FAILED,ATTEMPTS_LIMIT_EXCEEDED", "FAILED_TO_BOOK", "FAILED"],
				buttonText: "REPROCESS"
			}
		]
	}
];

export const MANUAL_PROCESS_OPTIONS: ManualProcessOption[] = [
	{
		value: "outside",
		text: "Transactions managed outside platform (error unresolved)"
	},
	{
		value: "directly",
		text: "Transactions paid directly by client"
	},
	{
		value: "others",
		text: "Other (please specify)"
	}
];
